// extracted by mini-css-extract-plugin
export default {"wrapper":"acl_wrapper__WZAmn","header":"acl_header__7jKLI","content":"acl_content__1JTj+"};